import React, { JSX } from 'react';
import {
  Avatar,
  Box,
  Button,
  Divider,
  Fade,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Popover,
  Theme,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { UserButton, UserMenuContainer } from './HeaderStyles';
import { NavigationMenuItem } from './headerMenuUtils';

interface HeaderUserSectionProps {
  user: { firstName?: string; email?: string } | null | undefined;
  name: string;
  theme: Theme;
  userMenuOpen: boolean;
  userMenuAnchor: HTMLElement | null;
  userMenuItems: NavigationMenuItem[];
  onLogin: () => void;
  onUserMenuOpen: (event: React.MouseEvent<HTMLElement>) => void;
  onUserMenuClose: () => void;
  onUserMenuAction: (item: NavigationMenuItem) => void;
}

export function HeaderUserSection(props: HeaderUserSectionProps): JSX.Element {
  if (!props.user) {
    return (
      <Button
        color="info"
        variant="contained"
        onClick={props.onLogin}
        sx={{
          display: { xs: 'none', sm: 'block' },
          color: props.theme.palette.primary.contrastText,
        }}
      >
        Login
      </Button>
    );
  }

  return (
    <>
      <UserButton
        onClick={props.onUserMenuOpen}
        aria-controls={props.userMenuOpen ? 'user-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={props.userMenuOpen ? 'true' : undefined}
      >
        <Avatar sx={{ width: 32, height: 32, bgcolor: props.theme.palette.secondary.main }}>
          {props.name.charAt(0).toUpperCase()}
        </Avatar>
        <Box sx={{ display: { xs: 'none', sm: 'block' } }}>{props.name}</Box>
        <ExpandMore fontSize="small" />
      </UserButton>
      <Popover
        id="user-menu"
        open={props.userMenuOpen}
        anchorEl={props.userMenuAnchor}
        onClose={props.onUserMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        TransitionComponent={Fade}
      >
        <UserMenuContainer>
          <List dense>
            {props.userMenuItems.map((item, index) =>
              item.group === 'divider' ? (
                <Divider key={`divider-${index}`} />
              ) : (
                <ListItem key={item.id}>
                  <ListItemButton onClick={() => props.onUserMenuAction(item)}>
                    {item.icon && <ListItemIcon sx={{ minWidth: 36 }}>{item.icon}</ListItemIcon>}
                    <ListItemText primary={item.label} />
                  </ListItemButton>
                </ListItem>
              )
            )}
          </List>
        </UserMenuContainer>
      </Popover>
    </>
  );
}
